// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"455fd950","6850":"0cac9b71","6942":"e9338791","9205":"dd78204f"}[chunkId] + ".chunk.css";
};